const openButton = document.querySelector('.free-gift-popup-button');
const closeButton = document.querySelector('.f-close-button');
const closeButton2nd = document.querySelector('.f-close.f-button');
const cartTrigger = document.querySelector('.f-cart-trigger.f-button');
const productFormButton = document.querySelector('.product-form__buttons .product-form__submit');
const questionIcon = document.querySelector('.free-gift-wrapper-question');

openButton && openButton.addEventListener('click', () => {
  document.body.classList.add('show-gift-popup');
})

document.body.addEventListener('click', (e) => {
  if (e.target.classList.contains('f-popup')) {
    document.body.classList.remove('show-gift-popup');
  }
})

closeButton.addEventListener('click', () => {
  document.body.classList.remove('show-gift-popup');
})

closeButton2nd.addEventListener('click', () => {
  document.body.classList.remove('show-gift-popup');
})

cartTrigger.addEventListener('click', () => {
  document.body.classList.remove('show-gift-popup');

  setTimeout(() => {
    productFormButton.click();
  }, 500);
})

questionIcon && questionIcon.addEventListener('click', () => {
  document.body.classList.add('show-gift-popup');
})